import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useScheduleActivityAccess = () => {
  const { isScheduleV3FlagEnabled, isLoading: isLoadingV3Flag } =
    SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const isLoading = isLoadingV3Flag;

  return {
    isScheduleActivityEnabled: !isLoading && isScheduleV3FlagEnabled,
    isLoading,
  };
};
